var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext, useState } from "react";
import { Chains } from "../constants/constants";
var ChainContext = React.createContext({
    // chain: Chains.NotSelected,
    chain: Chains.BSC,
    setChain: function () { },
});
export var useChain = function () {
    var _a = useContext(ChainContext), chain = _a.chain, setChain = _a.setChain;
    return [chain, setChain];
};
export var ChainContextProvider = function (_a) {
    var children = _a.children;
    // const [chain, setChain] = useState(Chains.NotSelected);
    var _b = useState(Chains.BSC), chain = _b[0], setChain = _b[1];
    return (_jsx(ChainContext.Provider, __assign({ value: { chain: chain, setChain: setChain } }, { children: children }), void 0));
};
//# sourceMappingURL=chainContext.js.map